import { render, staticRenderFns } from "./KeyboardHatsu.vue?vue&type=template&id=08a1c054&scoped=true&"
import script from "./KeyboardHatsu.vue?vue&type=script&lang=js&"
export * from "./KeyboardHatsu.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardHatsu.vue?vue&type=style&index=0&id=08a1c054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1c054",
  null
  
)

export default component.exports